import SongsAddMultiple from "@/features/songs/album/SongsAddMultiple";

export default function SongsAddPlaylist() {
  return <SongsAddMultiple source="playlist" />;
}
